/**
 * @ngdoc directive
 * @name footer
 *
 * @description
 * Page footer
 */
module.directive('footeravenir', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
            $scope.copyright = '© Glénans Avenir';

            // get all menu items
            var $watcherSite = $rootScope.$watchCollection('config.site', function (config) {
                if (config && config.footer) {
                    $scope.menuFooter = config.footer;
                }
            });
            // get copyright enhancement
            var $watcherGlobal = $rootScope.$watchCollection('config.global', function (config) {
                if (config && config.start_copyright) {
                    $scope.copyright += ' ' + config.start_copyright;
                }
            });

            // remove $watchers
            $scope.$on('$destroy', function () {
                $watcherSite();
                $watcherGlobal();
            });
        }],
        template:
                '<div class="aqua-footer">' +
                '  <div class="grid-main grid">' +
                /* copyright */
                '    <p class="aqua-footer--text grid-3 grid-12-m grid-12-s">{{copyright}}</p>' +
                /* navigation list */
                '    <nav class="grid-9 grid-12-m grid-12-s grid grid-right">' +
                '      <ul class="aqua-footer--nav grid-12-m grid-12-s grid">' +
                '        <li class="aqua-footer--nav-item" ng-repeat="link in menuFooter"><a ng-href="{{link.url}}" class="aqua-footer--nav-link">{{link.title}}</a></li>' +
                '      </ul>' +
                '    </nav>' +
                '  </div>' +
                '</div>'
    };
});